export enum PasswordType {
  SIGNUP = "SIGNUP",
  RECOVERY = "RECOVERY",
}
